export default __webpack_public_path__ + "static/stateoct-b68b104a3c3771c4bda5f6a86c033fce.jpg";